import { useCallback, useEffect, useMemo } from 'react'
import { KeyCodeEnum } from 'enums/keyCodes'

const MAX_TIMESTAMP_DIFF = 500

const pressedMap: Record<string, number> = {}

export const useHotKey = (keyCode: KeyCodeEnum | KeyCodeEnum[], onPress: undefined | (() => void)) => {
  const keyCodesPrepared = useMemo(() => (Array.isArray(keyCode) ? keyCode : [keyCode]), [keyCode])

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (keyCodesPrepared.includes(event.code as KeyCodeEnum)) {
        pressedMap[event.code] = event.timeStamp

        const timestamps = keyCodesPrepared
          .map((code: KeyCodeEnum) => pressedMap[code])
          .filter(Boolean)
          .sort((a, b) => a - b)

        if (
          timestamps.length === keyCodesPrepared.length &&
          timestamps[timestamps.length - 1] - timestamps[0] < MAX_TIMESTAMP_DIFF
        ) {
          onPress?.()
        }
      }
    },
    [onPress, keyCodesPrepared]
  )

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)

    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])
}
